import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { AuthLayout, Field } from "@/components/AuthLayout";
import { useAuth, homeFor } from "@/context/AuthContext";
import { errMsg } from "@/lib/api";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [form, setForm] = useState({ email: "", password: "" });
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      const u = await login(form.email, form.password);
      const next = new URLSearchParams(window.location.search).get("next");
      nav(next && next.startsWith("/") && !next.startsWith("//") ? next : homeFor(u.role));
    } catch (err) {
      setError(errMsg(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <AuthLayout title="Welcome back" subtitle="Sign in to your Luxury Rideshare account.">
      <form onSubmit={submit} className="space-y-5" data-testid="login-form">
        <Field label="Email or username" type="text" autoComplete="username" required data-testid="login-email-input" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} />
        <Field label="Password" type="password" required data-testid="login-password-input" value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} />
        {error && <p data-testid="login-error" className="rounded-lg border border-red-500/30 bg-red-500/10 px-4 py-3 text-sm text-red-300">{error}</p>}
        <button type="submit" disabled={busy} data-testid="login-submit-button" className="btn-gold w-full">
          {busy && <Loader2 className="h-4 w-4 animate-spin" />} Sign in
        </button>
      </form>
      <p className="mt-8 text-sm text-zinc-400">
        New to Luxury? <Link to="/signup" data-testid="goto-signup-link" className="text-amber-300 hover:text-amber-200">Create an account</Link>
      </p>
    </AuthLayout>
  );
}
